import cx from 'classnames';
import './Image.css';
import cn from './Image.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
export const Image = props => {
  let useImg = true;
  const style = {};
  const classNames = [];
  if (props.onClick || props.onPress) {
    classNames.push(cn.clickable);
  }
  if (props.mode) {
    switch (props.mode) {
      // camelCase names.
      case 'fit-height':
        classNames.push(cn.fitHeight);
        break;
      case 'fit-width':
        classNames.push(cn.fitWidth);
        break;
      case 'scale':
      case 'tile':
        useImg = false;
        style.backgroundImage = `url(${props.src})`;
      // Intentionally fall trough. Only scale-height & scale-width need to be camelCased.
      /* falls through */
      default:
        classNames.push(cn[props.mode]);
    }
  }
  const imageProps = {
    src: props.src,
    onLoad: props.onLoad,
    onError: props.onError
  };
  const wrapperProps = {
    onClick: e => {
      props.onClick?.(e);
      if (props.onPress) {
        e.preventDefault();
        props.onPress();
      }
    },
    style: {
      ...style,
      ...props.style
    },
    title: props.tooltip,
    ['data-testid']: props.testId,
    tabIndex: props.onPress ? 0 : undefined,
    onKeyPress: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        props.onPress?.();
      }
    }
  };
  if (useImg) {
    return /*#__PURE__*/_jsx("img", {
      ...imageProps,
      ...wrapperProps,
      alt: props.alt || '',
      className: cx(props.className, classNames, cn.img)
    });
  } else {
    // In the old component had a property of alt={props.alt} for the span?
    return /*#__PURE__*/_jsx("span", {
      "aria-label": props.alt || '',
      role: 'img',
      ...wrapperProps,
      className: cx(props.className, classNames, cn.span),
      children: /*#__PURE__*/_jsx("img", {
        ...imageProps,
        className: cn.hiddenImg,
        alt: props.alt || ''
      })
    });
  }
};
//# sourceMappingURL=Image.js.map